import { render } from "./Course.vue?vue&type=template&id=6988e2fc&scoped=true&lang=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=6988e2fc&lang=scss&scoped=true"
import "./Course.vue?vue&type=style&index=1&id=6988e2fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6988e2fc"]])

export default __exports__